import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { FadeUp } from '../components/Reveal';
import { ARTICLES } from '../data/articles';

export default function ArticlesIndex() {
  return (
    <div className="relative bg-ink-950 text-white" data-testid="articles-index">
      <Helmet>
        <title>Journal — Studio Legale Belliardo · International Practice</title>
        <meta name="description" content="Long-form notes on Italian civil procedure, recognition and enforcement of foreign judgments — written for foreign counsel and in-house teams working across the Italian border." />
      </Helmet>
      <Nav />
      <section className="pt-40 md:pt-52 pb-16 md:pb-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <FadeUp>
            <div className="flex items-center gap-4 text-white/50 mb-8">
              <span className="h-px w-8 bg-oxblood" />
              <span className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.3em]">Journal · Cross-Border Practice</span>
            </div>
          </FadeUp>
          <FadeUp delay={0.05}>
            <h1 className="font-serif font-light text-white text-6xl md:text-8xl lg:text-[8rem] leading-[0.95] tracking-tight max-w-5xl">
              Written notes <br /><em className="not-italic text-white/50">from the file room.</em>
            </h1>
          </FadeUp>
          <FadeUp delay={0.15}>
            <p className="mt-10 max-w-2xl text-lg text-white/70 leading-relaxed">
              Long-form notes on procedure, recognition and enforcement — written for foreign counsel and
              in-house teams working across the Italian border.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="pb-32 md:pb-40 border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {ARTICLES.map((a, i) => (
              <FadeUp key={a.slug} delay={i * 0.05}>
                <Link to={`/articles/${a.slug}`} data-testid={`article-card-${a.slug}`}
                  className="block bg-ink-900 h-full p-8 md:p-10 group hover:bg-ink-800 transition-colors duration-500">
                  <div className="flex items-baseline justify-between mb-6">
                    <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">— {a.country} · {a.read} min read</span>
                    <span className="font-mono text-[10px] text-white/30">{a.date}</span>
                  </div>
                  <h2 className="font-serif text-3xl md:text-4xl text-white font-light leading-[1.05] tracking-tight mb-4 group-hover:text-white transition-colors">
                    {a.title}
                  </h2>
                  <p className="text-white/60 leading-relaxed text-sm md:text-base">{a.excerpt}</p>
                  <div className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-white/50 group-hover:text-white transition-colors flex items-center gap-2">
                    Read the note
                    <span className="transition-transform duration-500 group-hover:translate-x-1">→</span>
                  </div>
                </Link>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
